import { IFlowEventData } from 'types/analytics';

export const LANDING_FLOW_STEP: Pick<IFlowEventData, 'flowStep'> = {
    flowStep: 'main'
};

export enum LANDING_FLOW_ACTIONS {
    DISPLAY = 'main landing page'
}
